import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Chip from '@mui/material/Chip';

import CardActions from 'components/Card/Actions';

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: 4,
    backgroundColor: theme.palette.background.paper,
  },
  label: {
    height: 24,
    lineHeight: '24px',
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: 8,
    paddingRight: 8,
  },
}));

const CardChips = ({ items, ...props }) => {
  const styles = useStyles();
  return (
    <CardActions {...props}>
      {items.map(
        useCallback(
          (item, idx) => (
            <Chip
              key={`chip-${idx}`}
              classes={{ label: styles.label, root: styles.chip }}
              label={item}
            />
          ),
          [styles],
        ),
      )}
    </CardActions>
  );
};

CardChips.propTypes = {
  ...CardActions.propTypes,
  children: PropTypes.node,
  items: PropTypes.array.isRequired,
};

export default CardChips;
